import React from 'react'
import {Link} from 'react-router-dom';
// Import Img
import img1 from '../../../assets/img/roar/avionestest.jpg'

const HomeTwoAbout = () => {
    return (
        <>
            <section id="service_about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="about_service_img">
                                <img src={img1} alt="img-about"/>
                            </div>
                        </div>
                        <div className="col-lg-6  col-md-12 col-sm-12 col-12">
                            <div className="about_service_text">
                                <div className="heading-left-border">
                                    <h2>¿Quienes somos?</h2>
                                </div>
                                <p>Somos una empresa conformada por emprendedores y profesionales que comprenden a la perfección las diversas necesidas de sus clientes en cuanto a logística del traslado y resguardo de vehículos.</p>
                                {/* <p>Monitoreando nuestras unidades con GPS vigilando el recorrido de la carga, garantizando seguridad y entrega de mercancia en tiempos.</p> */}
                                <Link to="/about" className="btn btn-theme">Conocer más</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeTwoAbout
